import { LocalStorageKey } from '@/constant/LocalStorageKey';

/**
 * 本地存储
 *@author caijing
 *@date 2022/3/2 14:02
 */
export class LocalStorageManager {
  static setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  static getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }

  static clear() {
    localStorage.clear();
  }

  static getUser() {
    let user;
    const userStr = LocalStorageManager.getItem(LocalStorageKey.user);
    if (userStr) {
      user = JSON.parse(userStr);
    }
    return user;
  }
}
